"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadBidder__factory = void 0;
const ethers_1 = require("ethers");
class BadBidder__factory extends ethers_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(_auction, _zora, overrides) {
        return super.deploy(_auction, _zora, overrides || {});
    }
    getDeployTransaction(_auction, _zora, overrides) {
        return super.getDeployTransaction(_auction, _zora, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.BadBidder__factory = BadBidder__factory;
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_auction",
                type: "address",
            },
            {
                internalType: "address",
                name: "_zora",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        stateMutability: "payable",
        type: "fallback",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "auctionId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "placeBid",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b506040516102093803806102098339818101604052604081101561003357600080fd5b810190808051906020019092919080519060200190929190505050816000806101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff16021790555080600160006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff1602179055505050610129806100e06000396000f3fe608060405260043610601f5760003560e01c806357c90de5146027576025565b36602557005b005b605a60048036036040811015603b57600080fd5b810190808035906020019092919080359060200190929190505050605c565b005b6000809054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1663b7751c718284846040518463ffffffff1660e01b815260040180838152602001828152602001925050506000604051808303818588803b15801560d757600080fd5b505af115801560ea573d6000803e3d6000fd5b5050505050505056fea26469706673582212206d0a7dd53ec14011741e986c03042e3ae9015cb888da88f9872d356aa1e70a8364736f6c63430006080033";
//# sourceMappingURL=BadBidder__factory.js.map